import { IMapDrawLayer, IMapGeometry, IMapGeometryPoint, IMapSettings } from "@components/map/map.settings";
import { IMapComponent } from "~app/common/components/map/map.models";
import { ITplDestineringRuttQueryResult } from "~app/features/transport/transportplanera/models/queries";
import { TplTransportavstandKartaLayers } from "./tpl-transportavstand-karta.layers";

export class TplTransportavstandKartaStartpunkt extends TplTransportavstandKartaLayers {

    load(data: ITplDestineringRuttQueryResult, mapsettings: IMapSettings, map: IMapComponent) {
        const geometries = [
{
    id: "startpunkt",
    label: "Startpunkt",
    easting: data.startPunkt.easting,
    northing: data.startPunkt.northing,
    iconid: "startpunktIcon",
    visible: true
} as IMapGeometryPoint
        ];

        mapsettings.drawLayers.find(x => x.id === "startpunkt").geometries = geometries;
        map.refreshGeometries("startpunkt");
    }

    getLayer() {
        return {
            id: "startpunkt",
            title: "Startpunkt",
            showGeometriesMenu: false,
            visible: true,
            readonly: true,
            selectable: false,
            autoZoom: true,
            zoomable: true,
            geometries: [],
            hideInLayerList: true,
            onClick: (mouseevent: any, geometry: any) => {
                this.parent.selectPoint(mouseevent, geometry, "startpunkt");
                return false;
            },
            onHoverIn: (geom: IMapGeometry, mouseevent: any) => this.hoverIn(geom, mouseevent),
            onHoverOut: (geom: IMapGeometry, mouseevent: any) => this.hoverOut(geom, mouseevent),
            drawOptions: [
                {
                    title: ``,
                    type: "point",
                    callback: (g) => {
                    // Kräver callback
                    },
                    onBeforeDraw: () => true
                }
            ]
        } as IMapDrawLayer;
    }
}
